import {m, wrap} from '@codeurs/front'
import {Component} from 'react'
import {Layout} from 'views/layout'
import {Theme} from 'views/theme'

@wrap(Layout)
export class Category extends Component {
	render() {
		return (
			<div>
				<Theme.Container>Category</Theme.Container>
			</div>
		)
	}
}
